import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PurchaseFeesDisclaimer from '../../containers/purchase-claim/purchase-fees-disclaimer.container';
import PurchaseImage from '../../../containers/purchase-image.container';
import TotalCostRange from '../../containers/purchase-claim/total-cost-range.container';
import PurchaseSummaryDetails from '../../containers/purchase-summary-details.container';
import StartAndEndDatetimes from '../../containers/purchase-claim/start-end-datetimes.container';
import FooterPoweredBy from '../../containers/footer-powered-by.container';
import LinkWithPopover from '../link-with-popover';
import { SMALL_LANDSCAPE } from '../../lib/image-versions';
import { formatMessage } from '../../lib/intl';
import pbgLogoBlue from '../../img/keytravel-logo-blue.png';
import '../../css/purchase-summary.css';

class ClaimPurchaseSummary extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  renderLanguage() {
    return this.formatMessage({ id: 'footer.languages.language' })
  }

  render() {
    return (
      <div className="purchase-summary">
        <div className="row">
          <div className="col-12">
            <div className="image-wrapper">
              <PurchaseImage version={SMALL_LANDSCAPE} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <PurchaseSummaryDetails />
          </div>
        </div>

        <div className="mt-3">
          <StartAndEndDatetimes />

          <div className="row mt-2">
            <div className="col-12">
              <TotalCostRange
                constraints={[{ elem: '.purchase-summary', pin: ['right'] }]}
              />
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <PurchaseFeesDisclaimer />
          </div>
        </div>

        <FooterPoweredBy pbgLogo={pbgLogoBlue} />

        <div className="purchase-summary-footer">
          <hr />
          <div className="row">
            <div className="col-7">
              <LinkWithPopover
                name="how-it-works"
                text={<FormattedMessage
                  id="claimPurchaseSummary.title"
                  defaultMessage="How does it work?"
                />}
                placement="top"
                className="how-it-works small"
              >
                <div>
                  <h4>
                    <FormattedMessage
                      id="claimPurchaseSummary.title"
                      defaultMessage="How does it work?"
                    />
                  </h4>
                  <ul className="small-print pl-0">
                    <li className="mt-2">
                      <FormattedMessage
                        id="claimPurchaseSummary.howDoesItWork.bullet1"
                        defaultMessage="- Rest easy and avoid fronting any money"
                      />
                    </li>
                    <li className="mt-2">
                      <FormattedMessage
                        id="claimPurchaseSummary.howDoesItWork.bullet2"
                        defaultMessage="- You control when to make the group's payment"
                      />
                    </li>
                    <li className="mt-2">
                      <FormattedMessage
                        id="claimPurchaseSummary.howDoesItWork.bullet3"
                        defaultMessage="- Automated updates keep you & your group informed"
                      />
                    </li>
                  </ul>
                </div>
              </LinkWithPopover>
            </div>
            <div className="col-5">
              <label>
                <select
                  className="purchase-summary-language-select"
                  value=""
                  onChange={this.props.onLanguageChange}
                >
                  <option>{this.renderLanguage()} &#9662;</option>
                  <option value="en">English</option>
                  <option value="es">Español (Latinoamérica)</option>
                  <option value="es-ES">Español (España)</option>
                  <option value="da">Dansk</option>
                  <option value="fr">Français</option>
                  <option value="it">Italiano</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ClaimPurchaseSummary);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/claim-purchase-summary.js